export default function Link(props) {
    const {link, blank} = props

    return <a href={link.href} target={blank ? '_blank': '_self'}>{link.title}</a>
}
